import { App as CapacitorApp } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { isAndroid, isNativePlatform } from './runtime';

let appStateHandle = null;
let backButtonHandle = null;
let launcherOpenHandler = null;

const openPanelFromNativeLauncher = () => {
  if (window.location.pathname !== '/panel') {
    window.history.replaceState(
      window.history.state,
      '',
      '/panel'
    );
    window.dispatchEvent(
      new PopStateEvent(
        'popstate',
        { state: window.history.state }
      )
    );
  }

  window.dispatchEvent(new Event('focus'));
};

export const initializeNativeShell = async () => {
  if (!isNativePlatform()) return;
  document.body.classList.add('pulsora-native');

  // PULSORA NATIVE SESSION PERSISTENCE V1
  if (!launcherOpenHandler) {
    launcherOpenHandler = openPanelFromNativeLauncher;
    window.addEventListener(
      'pulsora:native-launcher-open',
      launcherOpenHandler
    );
  }

  try {
    await StatusBar.setStyle({ style: Style.Light });
    if (isAndroid()) await StatusBar.setBackgroundColor({ color: '#0C1740' });
  } catch (_) {
    // El runtime web no implementa StatusBar; en native sí estará disponible.
  }

  try {
    appStateHandle = await CapacitorApp.addListener('appStateChange', ({ isActive }) => {
      document.body.classList.toggle('pulsora-app-background', !isActive);
      if (isActive) window.dispatchEvent(new Event('focus'));
    });

    if (isAndroid()) {
      backButtonHandle = await CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
          return;
        }

        CapacitorApp.minimizeApp();
      });
    }
  } catch (_) {
    appStateHandle = null;
  }
};

export const hideNativeSplash = async () => {
  if (!isNativePlatform()) return;
  try { await SplashScreen.hide(); } catch (_) { /* noop */ }
};

export const removeNativeLifecycleListeners = async () => {
  if (appStateHandle?.remove) await appStateHandle.remove();
  if (backButtonHandle?.remove) await backButtonHandle.remove();

  if (launcherOpenHandler) {
    window.removeEventListener(
      'pulsora:native-launcher-open',
      launcherOpenHandler
    );
  }

  appStateHandle = null;
  backButtonHandle = null;
  launcherOpenHandler = null;
};
